import React from 'react'

import PdsMarker, { PoiMarkerType } from '../components/PdsMarker'

export interface PdcMarkerProps {
  id?: string
  lat: number
  lng: number
  onMarkerCreate: (marker: H.map.Marker) => void
}

export default function PdcMarker({ id, lat, lng, onMarkerCreate }: PdcMarkerProps): JSX.Element {
  const markerId = id !== undefined ? id : ''
  return (
    <PdsMarker
      id={markerId}
      type={PoiMarkerType.hero}
      zIndex={1000}
      isHovered={false}
      lat={lat}
      lng={lng}
      onMarkerCreate={onMarkerCreate}
    />
  )
}
